// extracted by mini-css-extract-plugin
export default {"cards":"vX4UOOdOny7Kl54g3nKh","rotate":"XbwqOEmhHFFrt1NDVgVt","spin":"C9TfqrTewkXEB6BYUGn4"};